
    import {computed, ComputedRef, defineComponent, reactive, watch, toRefs} from 'vue'
    import {useStore} from "@/store";
    import reportMsgUt from "@/util/reportMsg";
    import common from "@/util/common";
    import {useRoute, useRouter} from "vue-router";
    import { Popup } from 'scvant';

    interface State {
        reportCode: string;
        showProtect: boolean;
        promiseTxt: string;
        isShowPop: boolean;
    }

    export default defineComponent({
        name: "summaryH5Promise",
        props: {
            renderData: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        setup(props: any) {
            const {query} = useRoute();
            let state: State = reactive({
                reportCode: '',
                showProtect: false,
                promiseTxt: '',
                isShowPop: false,

            })
            state.reportCode = `${query.reportCode}`;
            const {renderData} = toRefs(props);
            function getData(code, key='value', type='') {
                return common.getDataByCode(renderData.value, code, key, type)
            } 
            state.promiseTxt = `${getData('serviceOneTitleH5')}`;
            state.showProtect = !getData('rank').includes('D');
            // 获取路由器实例
            const router = useRouter()
            return {
                state,
                router,
                getData,
            }
        },
        components: {
            [Popup.name]: Popup,
        },
        methods: {
            toExplain() {
                let routerUrl = this.getData('serviceOneContentH5').replace('_','');
                routerUrl = routerUrl.charAt(0).toUpperCase() + routerUrl.slice(1);
                this.router.push({
                    path: `/promiseFrame${routerUrl}`,
                })
            },
            changePop() {
                this.state.isShowPop = !this.state.isShowPop;
            },
        }
    })
